import { ProcessingPerformance } from "@/telemetry/processing-performance"
import { processingQueue } from "./processing-queue"

let currentRun:
	| {
			projectId: string
			styleId: string
			measurement: ProcessingPerformance
	  }
	| undefined
let waitingForPhotos = false
const scheduling = new Set<symbol>()

export function beginAIStylePhoto(
	projectId: string,
	styleId: string,
	triggerSource: string | null = null,
) {
	if (currentRun?.projectId !== projectId || currentRun.styleId !== styleId) {
		currentRun?.measurement.finish("canceled")
		currentRun = {
			projectId,
			styleId,
			measurement: new ProcessingPerformance("ai_style", {
				projectId,
				styleId,
				triggerSource,
			}),
		}
	}
	currentRun.measurement.start()
	return currentRun.measurement
}

export function setAIStyleWaitingForPhotos(waiting: boolean) {
	waitingForPhotos = waiting
}

const isStyleTask = (task: { taskRecord?: { type: string } }) =>
	task.taskRecord?.type === "apply-style" || task.taskRecord?.type === "mark-reference"

export function finishAIStyleRunIfIdle() {
	if (!currentRun || waitingForPhotos || scheduling.size > 0) return
	for (const task of processingQueue.tasks.values()) {
		if (isStyleTask(task)) return
	}
	if (
		processingQueue.currentTask &&
		processingQueue.hasTask(processingQueue.currentTask, isStyleTask)
	)
		return
	currentRun.measurement.finish("completed")
	currentRun = undefined
}

// Reference updates can schedule more applications after an asynchronous/debounced gap.
export function holdAIStyleScheduling() {
	const token = Symbol()
	scheduling.add(token)
	return () => {
		scheduling.delete(token)
		finishAIStyleRunIfIdle()
	}
}

export function setupAIStylePerformance() {
	return processingQueue.queueEvents.subscribe((event) => {
		if (event === "clearQueue") {
			currentRun?.measurement.finish("canceled")
			currentRun = undefined
			waitingForPhotos = false
			scheduling.clear()
		} else if (event === "updateQueue") {
			finishAIStyleRunIfIdle()
		}
	})
}
